import { IUser } from "services/types";
import { Link } from "react-router-dom";

import { FollowButton } from "./FollowButton";
import { UnfollowButton } from "./UnfollowButton";
import VerifiedUserIcon from "components/UI/VerifiedUserIcon";
import { routes } from "routes";

import { ReactComponent as DefaultUserIcon } from "components/icons/default_userpic.svg";

import "./FollowingItem.scss";

export const FollowingItem = (props: {
  user: IUser;
  followed: boolean;
  onFollow: (username: string) => void;
}): JSX.Element => {
  const onFollow = (): void => {
    props.onFollow(props.user.username);
  };

  return (
    <div className="item">
      <Link className="thumbnail" to={routes.user(props.user.username)}>
        {props.user.profileImageUrl ? <img src={props.user.profileImageUrl} alt={props.user.username} /> : <DefaultUserIcon />}
      </Link>
      <div className="text">
        <div className="username">
          <Link to={routes.user(props.user.username)}>{props.user.name ?? props.user.username}</Link>
          {props.user.verified && <VerifiedUserIcon />}
        </div>
      </div>

      {props.followed && <UnfollowButton
        onClick={onFollow}
      />}

      {!props.followed && <FollowButton
        onClick={onFollow}
      />}
    </div>
  );
};
